const state = {
  session: null
}

const mutations = {
  SET_SESSION (state, session) {
    state.session = session
  }
}

const getters = {
  session: state => state.session
}

const actions = {
  setSession (context, session) {
    context.commit('SET_SESSION', session)
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
